'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var _reactI18next = require('react-i18next');

var _reduxForm = require('redux-form');

var _components = require('components');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var recipientsLinksFormDefaults = {
  link1: '',
  link2: ''
};

var RecipientsLinksForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    project: state.project.projectData,
    initialValues: state.project.projectData
  };
}, { editProjectLinks: _project.editProjectLinks }), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'RecipientsLinksForm',
  propNamespace: 'recipientsLinksForm',
  initialValues: recipientsLinksFormDefaults
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(RecipientsLinksForm, _Component);

  function RecipientsLinksForm() {
    (0, _classCallCheck3.default)(this, RecipientsLinksForm);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientsLinksForm.__proto__ || (0, _getPrototypeOf2.default)(RecipientsLinksForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientsLinksForm, [{
    key: 'saveLinks',
    value: function saveLinks(formData) {
      var _props = this.props,
          t = _props.t,
          projectId = _props.projectId;
      var link1 = formData.link1,
          link2 = formData.link2;

      return this.props.editProjectLinks(projectId, { link1: link1, link2: link2 }).promise.then(function () {
        return _toastr2.default.success(t('Links updated!'));
      }).catch(function (err) {
        return err;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          _props2$recipientsLin = _props2.recipientsLinksForm,
          handleSubmit = _props2$recipientsLin.handleSubmit,
          submitting = _props2$recipientsLin.submitting;


      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit(this.saveLinks), className: 'pos-rel' },
        _react2.default.createElement(
          'div',
          { className: 'formRow simple' },
          _react2.default.createElement(
            'div',
            null,
            t('Link'),
            ' 1'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reduxForm.Field, { name: 'link1', type: 'text', component: 'input' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'formRow simple' },
          _react2.default.createElement(
            'div',
            null,
            t('Link'),
            ' 2'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reduxForm.Field, { name: 'link2', type: 'text', component: 'input' }),
            _react2.default.createElement(
              'div',
              { className: 'hint small' },
              t('Optional. Add connected website links to the email.')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'formRow simple' },
          _react2.default.createElement('div', null),
          _react2.default.createElement(
            'div',
            { className: 'text-right' },
            _react2.default.createElement(
              'button',
              { type: 'submit', className: 'btn btn-default wide pos-rel', disabled: submitting },
              t('Update'),
              submitting && _react2.default.createElement(_components.Loader, { mask: true, small: true })
            )
          )
        )
      );
    }
  }]);
  return RecipientsLinksForm;
}(_react.Component), _class3.propTypes = {
  editProjectLinks: _propTypes2.default.func,
  projectId: _propTypes2.default.number.isRequired,
  recipientsLinksForm: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'saveLinks', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'saveLinks'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = RecipientsLinksForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/LinksForm.js
// module id = 2086
// module chunks = 1